export class ExternalIdsHelper {
  static extractEnelEmployeeId(externalUserIds: any[]): string {
    if (!externalUserIds || externalUserIds.length === 0) {
      return '';
    }

    const enelitIdEntry = externalUserIds.find((entry: any) => entry.ENELIT_ID);
    return enelitIdEntry ? enelitIdEntry.ENELIT_ID : '';
  }
}
